import { lazy } from "react";

const routes = [
  {
    path: "/",
    exact: true,
    component: lazy(() => import("./views/Start")),
  },
  {
    path: "/evaluation",
    exact: true,
    component: lazy(() => import("./views/Evaluation")),
  },
  {
    path: "/details",
    exact: true,
    component: lazy(() => import("./views/Details")),
  },
  {
    path: "/welcome",
    exact: true,
    component: lazy(() => import("./views/Welcome")),
  },
  {
    path: "/processing-results",
    exact: true,
    component: lazy(() => import("./views/ProcessingResults")),
  },
  {
    path: "/results",
    exact: true,
    component: lazy(() => import("./views/Results")),
  },
  {
    path: "/thank-you",
    exact: true,
    component: lazy(() => import("./views/ThankYou")),
  },
];

export default routes;
